import type { CSSProperties, FC } from 'react';
import { Image } from '~/common/components/image';
import { Link } from '~/common/components/link';
import { routes } from '~/utils/routes';

import bannerPng from './assets/banner.png';

type Props = {
  style?: CSSProperties;
};

export const CopyrightProtectionBanner: FC<Props> = ({ style }) => {
  return (
    <Link
      href={
        routes['handbook']['community-guideline']['copyright-protection'].url
      }
      style={{
        justifyContent: 'flex-start',
        ...style,
      }}
    >
      <Image
        src={bannerPng}
        alt="画像アップロード時の注意（著作権編）"
        loading="lazy"
        w={{
          base: '100%',
          md: '50%',
        }}
        htmlHeight="100%"
      />
    </Link>
  );
};
